import {
  buildAcmt023,
  buildAcmt024,
  DEFAULT_ACMT023_INPUT,
  freshAcmt023Input,
  type Acmt023Input,
} from './acmt023Builder';
import {
  ACMT023_EXPERT_SECTIONS,
  ACMT023_FIELDS,
  ACMT023_SIMPLE_SECTIONS,
} from './acmt023Fields';
import {
  buildCamt056,
  buildCamt029,
  DEFAULT_CAMT056_INPUT,
  freshCamt056Input,
  type Camt056Input,
} from './camt056Builder';
import {
  CAMT056_EXPERT_SECTIONS,
  CAMT056_FIELDS,
  CAMT056_SIMPLE_SECTIONS,
} from './camt056Fields';
import {
  buildPain001,
  buildPain002,
  DEFAULT_PAIN001_INPUT,
  freshPain001Input,
  type Pain001Input,
} from './pain001Builder';
import {
  PAIN001_EXPERT_SECTIONS,
  PAIN001_FIELDS,
  PAIN001_SIMPLE_SECTIONS,
  PAIN001_SIMPLE_SYNC,
} from './pain001Fields';
import type { BuilderInput, StructuredBuilderDef } from './types';

function asInput<T extends object>(value: T): BuilderInput {
  return value as BuilderInput;
}

export const PAIN001_BUILDER: StructuredBuilderDef = {
  short: 'pain.001',
  pairShort: 'pain.002',
  fields: PAIN001_FIELDS,
  simpleSections: PAIN001_SIMPLE_SECTIONS,
  expertSections: PAIN001_EXPERT_SECTIONS,
  simpleSync: PAIN001_SIMPLE_SYNC,
  defaultInput: asInput(DEFAULT_PAIN001_INPUT),
  freshInput: () => asInput(freshPain001Input()),
  buildPrimary: (input) => buildPain001(input as unknown as Pain001Input),
  buildPair: (input, outcome, reason) => buildPain002(input as unknown as Pain001Input, outcome, reason),
  outcome: {
    options: ['ACTC', 'RJCT'],
    default: 'ACTC',
    rejectOptions: ['AC01', 'AC03', 'AC04', 'AM04', 'AG01', 'AM02', 'DT01'],
    rejectWhen: 'RJCT',
  },
  outcomeFieldKeys: ['outcome', 'rejectReason'],
};

export const CAMT056_BUILDER: StructuredBuilderDef = {
  short: 'camt.056',
  pairShort: 'camt.029',
  fields: CAMT056_FIELDS,
  simpleSections: CAMT056_SIMPLE_SECTIONS,
  expertSections: CAMT056_EXPERT_SECTIONS,
  defaultInput: asInput(DEFAULT_CAMT056_INPUT),
  freshInput: () => asInput(freshCamt056Input()),
  buildPrimary: (input) => buildCamt056(input as unknown as Camt056Input),
  buildPair: (input, outcome) => buildCamt029(input as unknown as Camt056Input, outcome),
  outcome: {
    options: ['ACCR', 'RJCR'],
    default: 'ACCR',
    rejectWhen: 'RJCR',
  },
  outcomeFieldKeys: ['outcome'],
};

export const ACMT023_BUILDER: StructuredBuilderDef = {
  short: 'acmt.023',
  pairShort: 'acmt.024',
  fields: ACMT023_FIELDS,
  simpleSections: ACMT023_SIMPLE_SECTIONS,
  expertSections: ACMT023_EXPERT_SECTIONS,
  defaultInput: asInput(DEFAULT_ACMT023_INPUT),
  freshInput: () => asInput(freshAcmt023Input()),
  buildPrimary: (input) => buildAcmt023(input as unknown as Acmt023Input),
  buildPair: (input, outcome, reason) => buildAcmt024(input as unknown as Acmt023Input, outcome, reason),
  outcome: {
    options: ['MTCH', 'NMTC'],
    default: 'NMTC',
    rejectWhen: 'NMTC',
  },
  outcomeFieldKeys: ['outcome'],
};

export const STRUCTURED_BUILDERS: Record<string, StructuredBuilderDef> = {
  'pain.001': PAIN001_BUILDER,
  'camt.056': CAMT056_BUILDER,
  'acmt.023': ACMT023_BUILDER,
};

export function structuredBuilderFor(short: string): StructuredBuilderDef | undefined {
  return STRUCTURED_BUILDERS[short];
}
